import { memo, useMemo } from "react";

import { type RenderGroupRowCellProps } from ".";
import { getIacManagementStackVendorMeta } from "../../helpers";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import useCellFilterAction from "../useCellFilterAction";
import IacManagementGroupCell from "../components/GroupCell";
import IacManagementTableVendorCell from "../components/VendorCell";

const IacManagementTableGroupRowCellVendor = memo((props: RenderGroupRowCellProps) => {
  const { row } = props;

  const isStackRow = row.__typename === "ManagedEntitiesGroupedByStacks";

  const vendor = (isStackRow && row.stackVendor) || undefined;
  const vendorMeta = vendor && getIacManagementStackVendorMeta(vendor);

  const vendorFilterAction = useCellFilterAction(
    ResourcesSuggestions.Vendor,
    vendorMeta?.text || ""
  );

  const actions = useMemo(
    () => (vendorMeta ? [vendorFilterAction] : []),
    [vendorMeta, vendorFilterAction]
  );

  return (
    <IacManagementGroupCell {...props} actions={actions}>
      <IacManagementTableVendorCell vendorMeta={vendorMeta} />
    </IacManagementGroupCell>
  );
});

IacManagementTableGroupRowCellVendor.displayName = "IacManagementTableGroupRowCellVendor";

export default IacManagementTableGroupRowCellVendor;
